export enum PaymentStatus {
  SUCCESS = 'SUCCESS',
  FAIL = 'FAIL',
}
export enum RedirectTarget {
  HOME = 'home',
  BOOKING = '',
}
